module.exports = __webpack_public_path__ + "img/img1.a2ea4d8e.svg";